var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frontend"},[_c('MarketplaceProductsCreationUser',{attrs:{"MP":_vm.MP,"categories":_vm.categories},on:{"save":_vm.saveMarketplaceProduct}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }